<template>
  <section>
    <section class="hero is-dark mainContent">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="title">Informes</h1>
              <h2 class="subtitle">Plantillas</h2>
            </div>

          </div>
        </div>
      </div>
    </section>

    <section class="section mainContent">
      <div class="tabs topSubMenu">
        <ul>
          <router-link
              custom
              v-slot="{ navigate }"
              :to="{ name: 'listview' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Ver informes</a>
            </li>
          </router-link>
        </ul>
        <ul>
          <router-link
              custom
              v-slot="{ navigate }"
              :to="{ name: 'listview.crea' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Crear informe</a>
            </li>
          </router-link>
        </ul>
        <ul>
          <router-link
              custom
              v-slot="{ navigate }"
              :to="{ name: 'listview.carpetaslist' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Editar Informes</a>
            </li>
          </router-link>
        </ul>
        <ul class='selectedMenu'>
          <router-link
              custom
              v-slot="{ navigate }"
              :to="{ name: 'listview.plantillalist' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Plantillas</a>
            </li>
          </router-link>
        </ul>
        <ul>
          <router-link
              custom
              v-slot="{ navigate }"
              :to="{ name: 'listview.guides' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Guías</a>
            </li>
          </router-link>
        </ul>
      </div>

      <div class="container">
        <div class="column">
          <div class="field">
            <div class="control has-icons-left has-icons-right">
              <input class="input is-large" type="text" v-model="search" placeholder="Buscar"/>
              <span class="icon is-medium is-left">
                <i class="material-icons">search</i>
              </span>
              <span class="icon is-medium is-right">
                <i class="fas fa-check fa-lg"></i>
              </span>
            </div>
          </div>
        </div>

        <table class="table is-fullwidth">
          <thead>
          <tr>
            <th></th>
            <th>Plantilla informe</th>

            <th>Controles</th>
            <th v-if="empresa.nit==nit">Pública</th>

          </tr>
          </thead>
          <tbody>
          <tr v-for="info in filteredItems" :key="info.$index">
            <td>{{ info.$index }}</td>
            <td>
              <h5 class="is-size-3">{{ info.nombre }}</h5>
            </td>

            <td>
              <button class="button is-danger" @click="eliminar(info)">
                  <span data-tooltip="Eliminar" class="icon tooltip">
                    <i class="material-icons">delete_forever</i>
                  </span>
              </button>
              <router-link
                  :to="{ name: 'editinforme', params: { tipo:'plantilla',id: info.id } }"
                  class="button is-info"
              >
                  <span data-tooltip="Editar" class="icon tooltip">
                    <i class="material-icons">edit</i>
                  </span>
              </router-link>
              <button
                  class="button"
                  :class="{'is-warning': info.isfrs, 'is-light': !info.isfrs }"
                  @click="selectasfrs(info)"
              >
                 <span data-tooltip="Poner En Favorito" class="icon tooltip">
                  <i class="material-icons">star</i>
                </span>
              </button>


            </td>
            <td v-if="empresa.nit==nit">
              <input type="checkbox" class="checkbox customCheck" @change="setpublic(info)" v-model="info.ispublic"/>
            </td>
            <!-- <td>
              <h6 v-if="empresa.nit==nit" class="subtitle is-7">{{info.cliente}}</h6>
            </td> -->
          </tr>
          </tbody>
        </table>
      </div>
    </section>
  </section>
</template>

<script>
import {mapState} from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";

export default {
  data() {
    return {
      isfrs: false,
      plantillas: [],
      search: "",
      nit: "901452692-4"
    };
  },
  computed: {
    ...mapState(["idtoken", "modalnotification", "empresa"]),
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
    filteredItems: function () {
      return functions.filterItems(this.search, this.plantillas, [
        {cod: "nombre"},
        {cod: "cliente"}
      ]);
    }
  },
  methods: {
    async selectasfrs(info) {
      const query = {
        id: info.id
      }
      try {
        const result = await apiServices.post(`/editasfrs`, query);
        if (result.data) {
          this.traeInformes(this);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async setpublic(info) {

      const query = {
        id: info.id,
        ispublic: info.ispublic
      }

      console.log("query", query);
      try {
        const result = await apiServices.post(`/editaispublic`, query);
        if (result.data) {
          this.traeInformes(this);
        }
      } catch (err) {
        console.log(err);
      }
    },
    eliminar(inf) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: "¿Realmente desea eliminar la plantilla?",
          clase: "is-white",
          data: inf.id
        }
      });
    },
    async traeInformes(_this) {
      let result;
      try {
        result = await apiServices.get(`/plantillas`);
        _this.plantillas = [];
        result.data.forEach(el => {
          const d = {
            nombre: el.title,
            id: el._id,
            isfrs: el.isfrs,
            ispublic: el.ispublic,
            cliente: el.cliente.nombre
          };
          _this.plantillas.push(d);
        });
      } catch (err) {
        console.log(err);
      }
    },
    async deleteInformes(_this, id) {
      try {
        await apiServices.delete(`/plantilla/${id}`);
        _this.traeInformes(_this);
      } catch (err) {
        console.log(err);
      }
    }
  },
  created() {
    if (this.idtoken) {
      this.traeInformes(this);
    }
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.traeInformes(this);
      }
    },
    resultnotification(nv, ov) {
      if (nv) {
        this.deleteInformes(this, this.modalnotification.result.data);
      }
    }
  }
};
</script>

<style lang='scss' scoped>

.mainContent {
  padding: 0px 60px;
}

.topSubMenu {
  padding: 0px 60px;
  margin: 10px 0px 5px 0px;
}

.selectedMenu li a {
  color: #510087;
  font-weight: bold;

}

.customCheck {
  height: 30px;
  width: 30px;
  border: 1px solid #fcfcfc;
}
</style>




// WEBPACK FOOTER //
// src/components/informes/Listplantilla.vue